<template>
	<div class="z-10">
		<div class="flex flex-wrap gap-1 lg:gap-2">
			<CarbarBadge
				v-if="tags?.recently_added"
				:background-color="badgeColorDefault"
			>
				Recently added
			</CarbarBadge>
			<CarbarBadge
				v-if="tags?.is_new && pageType === 'subscribe'"
				:background-color="badgeColorDefault"
			>
				Brand new
			</CarbarBadge>
			<CarbarBadge
				v-if="tags?.is_demo && pageType === 'subscribe'"
				background-color="bg-gray-600"
			>
				Demo
			</CarbarBadge>
			<CarbarBadge
				v-if="tags?.is_available_now"
				:background-color="badgeColorDefault"
			>
				Available now
			</CarbarBadge>
			<CarbarBadge
				v-if="showPromoBadge"
				:background-color="badgeColor"
				:text-color="badgeTextColor"
			>
				{{ badgeText }}
			</CarbarBadge>
		</div>
	</div>
</template>

<script setup>
import CarbarBadge from '@/components/badges/CarbarBadge.vue'

const props = defineProps({
	tags: {
		type: Object,
		required: true,
	},
	discountSet: {
		type: Object,
		required: true,
	},
	pageType: {
		type: String,
		required: true,
	},
})

const showPromoBadge = computed(() => hasValidDiscountSet(props.discountSet))

const { badgeText, badgeColor, badgeTextColor } = getCampaignBadgeInfo(
	props.discountSet
)

const { partnerName } = useGetPartnerName()
const { whitelabel } = useWhitelabelsStyles()

const badgeColorDefault = computed(() => {
	return partnerName.value
		? whitelabel.value?.styles?.bg?.color
		: 'bg-blue-400'
})
</script>
